<template>
  <div class="user-bar">
    <a-dropdown>
      <div class="panel-item">
        <a-avatar :src="$app.store?.info.logo?.min" />
        <span>{{ $app.store?.name }}</span>
        <huasky-icon style="margin-left: 5px;" icon="CaretDownOutlined" />
      </div>
      <template #overlay>
        <a-menu>
          <a-menu-item key="center" @click="() => $router.push('/store/userCenter')">
            <huasky-icon icon="UserOutlined" style="margin-right: 8px" />
            <span>商户中心</span>
          </a-menu-item>
          <a-menu-item key="back" v-if="!!linkageId" @click="() => goStore(linkageId)">
            <huasky-icon icon="LeftSquareOutlined" style="margin-right: 8px" />
            <span>返回连锁店</span>
          </a-menu-item>
          <a-menu-item key="logout" @click="() => logout()">
            <huasky-icon icon="ExportOutlined" style="margin-right: 8px" />
            <span>退出登录</span>
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
  </div>
</template>
<script setup lang="ts">
import { getLinkageId, goStore, logout } from '@src/scripts/system'

const linkageId = getLinkageId()



</script>
<style lang="less" scoped>
.user-bar {
  display: flex;
  align-items: center;
  height: 100%;
}

.user-bar .panel-item {
  padding: 0 10px;
  cursor: pointer;
  height: 100%;
  display: flex;
  align-items: center;
  line-height: 50px;
  font-size: .7em;
  color: #777;
}

.user-bar .panel-item:hover {
  background: #ebebeb;
  cursor: pointer;
}

.user-bar .panel-item span {
  margin-left: 5px;
  cursor: pointer;
}

</style>